/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {ImportSSLCertificate} from 'types/ImportSSLCertificate';
import {SslKeyNames} from './diplomat/keys/SslNames';

export const ImportClientSSLCertificate = ImportSSLCertificate.shape({
   [SslKeyNames.passphrase]: yup.string().required(),
});
export type IImportClientSSLCertificate = yup.InferType<typeof ImportClientSSLCertificate>;
